export const GET_TOTAL_STATS = 'CASH-IN/get_total_stats';
export const GET_GRAPH_STATS = 'CASH-IN/get_graph_stats';
